import Image from 'next/legacy/image';
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react';
import { TextInputType } from '../../../FormFields/shared';
import { Input } from '../../../Input/styles';
import searchIcon from '@/images/search-icon.svg';
import rightArrowIcon from '@/images/right-filled-bullet.svg';

interface SearchInputProps {
  hideSubmitButton?: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export function SearchInput({
  hideSubmitButton = false,
  value,
  onChange,
  onSubmit
}: SearchInputProps) {
  const [searchValue, setSearchValue] = useState('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.currentTarget.value;
    setSearchValue(newValue);
    onChange(newValue.trim());
  };
  const handleKeydown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (/^(Numpad)?Enter/.test(event.code)) {
      onSubmit();
    }
  };

  useEffect(() => setSearchValue(value), [value]);

  return (
    <div className="relative h-full w-full">
      <div className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[0px] leading-none">
        <Image alt="" src={searchIcon} width={22} height={22} />
      </div>
      <Input
        data-testid="search-box"
        name="subject"
        type={TextInputType.SEARCH}
        inputMode="search"
        removeCancelButton={true}
        value={searchValue}
        onChange={handleChange}
        onKeyDown={handleKeydown}
        placeholder="Search a topic, tag, title..."
        className={`bg-transparent h-full w-full !rounded-full !border-teal !py-3 !pl-10 !text-base placeholder:!font-normal ${
          hideSubmitButton ? '!pr-6' : '!pr-12'
        }`}
      />
      {hideSubmitButton ? null : (
        <button
          data-testid="search-box-submit-button"
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[0px] leading-none"
          onClick={onSubmit}
          aria-label="Submit search query using right arrow button"
          title="Submit search query"
        >
          <Image alt="" src={rightArrowIcon} width={32} height={32} />
        </button>
      )}
    </div>
  );
}
